function initBestelformulier() {
    var shopItems = [];


    var StaffelPrijs = function (aantal, staffel, single_prijs) {
        var closestStaffel = parseFloat(single_prijs);


        if (staffel && staffel.length > 0) {
            var i = 0;
            var len = staffel.length;


            var currentStaffel;
            for (i; i < len; i++) {
                currentStaffel = staffel[i];
                if (aantal >= currentStaffel.aantal) {
                    closestStaffel = parseFloat(currentStaffel.prijs);
                } else if (aantal < currentStaffel.aantal) {
                    break;
                }

            }
        }

        console.log(closestStaffel);
        return closestStaffel;

    }

    var roundPrijs = function (prijs) {
        console.log(prijs);
        prijs = Math.round(prijs * 100) / 100;
        return prijs;

    }
    var CalculateDeegPrijs = function (item, aantalDeeg, aantalDagen, includeMachines) {

        var deegMetMachinePrijs = StaffelPrijs(aantalDeeg, item.staffel_prijzen_deeg_met_machines, item.deegprijs_met_machine);

        var deegZonderMachinePrijs = StaffelPrijs(aantalDeeg, item.staffel_prijzen_deeg_zonder_machines, item.deegprijs_zonder_machine);
        var machineDagPrijs = item.prijs_machine;

        if (includeMachines) {


            prijs = aantalDeeg * deegMetMachinePrijs + ((aantalDagen - 1) * machineDagPrijs);
        } else {
            prijs = aantalDeeg * deegZonderMachinePrijs;
        }
        return roundPrijs(prijs);
    };
    var CalculateMachinePrijs = function (item, aantalMachines, aantalDagen) {
        return item.prijs_machine * aantalDagen * aantalMachines;
    }
    var CalculateGebakkenPrijs = function (item, aantalStuks) {
        return roundPrijs(aantalStuks * StaffelPrijs(aantalStuks, item.staffel_prijzen_gebakken ,item.prijs_gebakken)); //item.prijs_gebakken;
    }

    var ShoppingItem = function (item, parent) {
        var self = this;
        self.item = ko.observable(item);
        self.aantalDeeg = ko.observable(0);
        self.includeMachines = ko.observable(false);

        self.aantalMachines = ko.observable(0);

        self.aantalGebakken = ko.observable(0);

        self.aantalDagen = ko.computed(function () {
            if (parent) {
                return parent.aantalDagen();
            } else {
                return 1;
            }
        });

        self.prijs = ko.computed(function () {
            var item = self.item();

            var aantalDeeg = self.aantalDeeg();
            var includeMachines = self.includeMachines() == true;
            var aantalMachines = self.aantalMachines();
            var aantalGebakken = self.aantalGebakken();
            var aantalDagen = self.aantalDagen();



            var prijs = 0;
            if (aantalDeeg > 0) {
                prijs = CalculateDeegPrijs(item, aantalDeeg, aantalDagen, includeMachines);
            } else if (aantalMachines > 0) {
                prijs = CalculateMachinePrijs(item, aantalMachines, aantalDagen);

            } else if (aantalGebakken > 0) {
                prijs = CalculateGebakkenPrijs(item, aantalGebakken);
            }



            return prijs;
        });

        self.deleteDeeg = function () {
            self.aantalDeeg(0);


        }

        self.deleteMachinesBijDeeg = function () {

            self.includeMachines(false);



        }

        self.deleteMachines = function () {

            self.aantalMachines(0);



        }

        self.deleteGebakken = function () {

            self.aantalGebakken(0);

        }
        self.isEmpty = ko.computed(function () {
            var empty = self.aantalDeeg() == 0 && self.aantalMachines() == 0 && self.aantalGebakken() == 0;
            if (empty && parent) {
                parent.deleteShoppingItem(self);
            }
            return empty;
        });

    }

    var BestelFormulier = function (shopitems, validator) {
        var self = this;


        self.validator = validator;

        self.shopitems = ko.observableArray(shopitems);
        self.submitted = ko.observable(false);
        self.submitSuccess = ko.observable(false);
        self.datum_afhalen = ko.observable(moment().add(1, 'days').format("YYYY-MM-DD"));
        self.datum_terugbrengen = ko.observable(moment().add(2, 'days').format("YYYY-MM-DD"));

        function checkDate() {
            var afhalen = moment(self.datum_afhalen());
            var diff1 = afhalen.diff(moment(), 'days');
            if (diff1 < -1) {
                afhalen = moment().add(1, 'days');
                self.datum_afhalen(afhalen.format("YYYY-MM-DD"));
            }
            var terugbrengen = moment(self.datum_terugbrengen());
            var diff = afhalen.diff(terugbrengen, 'days');
            if (diff > -1) {
                self.datum_terugbrengen(afhalen.add(1, 'days').format("YYYY-MM-DD"));
            }
        }
        self.datum_afhalen.subscribe(function (value) {
            checkDate();
        });
        self.datum_terugbrengen.subscribe(function (value) {
            checkDate();
        });
        self.aantalDagen = ko.computed(function () {
            var afhalen = moment(self.datum_afhalen());
            var terugbrengen = moment(self.datum_terugbrengen());
            return terugbrengen.diff(afhalen, 'days');
        });

        self.shoppingCart = ko.observableArray([]);
        self.showReturnDate = ko.computed(function () {

            var first = ko.utils.arrayFirst(self.shoppingCart(), function (item) {
                return (item.aantalDeeg() > 0 && item.includeMachines()) || item.aantalMachines() > 0;

            });
            return (first) ? true : false;

        });
        self.contactInfo_Voornaam = ko.observable("");
        self.contactInfo_FamilieNaam = ko.observable("");
        self.contactInfo_Adres_Straat = ko.observable("");
        self.contactInfo_Adres_Nummer = ko.observable("");
        self.contactInfo_Adres_Postcode = ko.observable("");
        self.contactInfo_Adres_Stad = ko.observable("");
        self.contactInfo_Telefoon = ko.observable("");
        self.contactInfo_Email = ko.observable("");

        self.openItem = ko.observable({});
        self.openMode = ko.observable("");

        self.comment = ko.observable("");

        self.openItem_DeegBestellen_IncludeMachines = ko.observable(false);
        self.openItem_DeegBestellen_AantalStuks = ko.observable(0);
        self.minimumDeeg = 50;
        self.stepDeeg = 10;
        self.openItem_DeegBestellen_AantalStuksValid = ko.computed(function () {
            return self.openItem_DeegBestellen_AantalStuks() >= self.minimumDeeg && self.openItem_DeegBestellen_AantalStuks() % self.stepDeeg == 0;
        });

        /*self.openItem_DeegBestellen_AantalStuks.subscribe(function (value) {
            if (value > 10) {
                if (value < self.minimumDeeg) {
                    value = self.minimumDeeg;
                }
                var rest = value % self.stepDeeg;
                if (rest > 0) {
                    value = -rest;
                }
                self.openItem_DeegBestellen_AantalStuks(value);
            }
        });*/

        self.openItem_DeegBestellen_Prijs = ko.computed(function () {
            return CalculateDeegPrijs(self.openItem(), self.openItem_DeegBestellen_AantalStuks(), self.aantalDagen(), self.openItem_DeegBestellen_IncludeMachines() == true);
        });
        self.openItem_MachinesBestellen_AantalMachines = ko.observable(0);
        self.openItem_MachinesBestellen_Prijs = ko.computed(function () {
            return CalculateMachinePrijs(self.openItem(), self.openItem_MachinesBestellen_AantalMachines(), self.aantalDagen());
        });
        self.openItem_GebakkenBestellen_AantalStuks = ko.observable(0);
        self.openItem_GebakkenBestellen_Prijs = ko.computed(function () {
            return CalculateGebakkenPrijs(self.openItem(), self.openItem_GebakkenBestellen_AantalStuks());
        });
        self.totaalPrijs = ko.computed(function () {
            var total = 0;
            ko.utils.arrayForEach(self.shoppingCart(), function (item) {
                var value = parseFloat(item.prijs());
                if (!isNaN(value)) {
                    total += value;
                }
            });
            return total.toFixed(2);
        });
        self.openItemParent = ko.computed(function () {
            var returnItem = null
            if (self.openItem() != {} && self.openItem().parentID != 0) {

                returnItem = ko.utils.arrayFirst(self.shopitems(), function (item) {

                    return item.postID == self.openItem().parentID;
                });
            } else {
                returnItem = self.openItem();
            }
            // console.log(returnItem);
            return returnItem;
        });


        self.comment = ko.observable("");
        self.formInvalid = ko.observable(false);
        // functies
        self.openDeegBestellen = function (value) {
            //  console.log(value);
            self.clearDeegBestellen(value);
            self.openMode("deeg");
            self.openItem(value);

        }
        self.clearDeegBestellen = function (value) {
            self.openItem({});
            self.openItem_DeegBestellen_IncludeMachines(false);
            self.openItem_DeegBestellen_AantalStuks(0);

        }
        self.doDeegBestellen = function (value) {
            // add to shopping basket

            if (value != self.openItem()) {
                value = self.openItem();
            }

            var orderLine = new ShoppingItem(value, self);

            orderLine.aantalDeeg(self.openItem_DeegBestellen_AantalStuks());
            orderLine.includeMachines(self.openItem_DeegBestellen_IncludeMachines());
            orderLine.aantalMachines(0);
            orderLine.aantalGebakken(0);

            self.clearDeegBestellen(value);
            // console.log(orderLine.prijs());
            addToShoppingcart(orderLine);

        }
        self.openMachinesBestellen = function (value) {


            self.clearDeegBestellen(value);
            self.openMode("machines");
            self.openItem(value);
        }
        self.clearMachinesBestellen = function (value) {


            self.openItem({});
            self.openItem_MachinesBestellen_AantalMachines(0);


        }
        self.doMachinesBestellen = function (value) {

            if (value != self.openItem()) {
                value = self.openItem();
            }
            var orderLine = new ShoppingItem(value, self);

            orderLine.aantalDeeg(0);

            orderLine.includeMachines(false);
            orderLine.aantalMachines(self.openItem_MachinesBestellen_AantalMachines());
            orderLine.aantalGebakken(0);
            addToShoppingcart(orderLine);
            self.clearMachinesBestellen(value);


        }
        self.openGebakkenBestellen = function (value) {
            self.clearDeegBestellen(value);
            self.openMode("gebakken");
            self.openItem(value);
        }
        self.clearGebakkenBestellen = function (value) {
            self.openItem({});
            self.openItem_GebakkenBestellen_AantalStuks(0);


        }
        self.doGebakkenBestellen = function (value) {
            if (value != self.openItem()) {
                value = self.openItem();
            }
            var orderLine = new ShoppingItem(value, self);

            orderLine.aantalDeeg(0);

            orderLine.includeMachines(false);
            orderLine.aantalMachines(0);
            orderLine.aantalGebakken(self.openItem_GebakkenBestellen_AantalStuks());
            addToShoppingcart(orderLine);
            self.clearGebakkenBestellen(value);


        }
        self.deleteShoppingItem = function (value) {

            self.shoppingCart.remove(value);
        }

        function addToShoppingcart(orderline) {


            /*var exists = ko.utils.arrayFirst(self.shoppingCart(), function (item) {
            return orderline.item().postID == item.item().postID;
            });

            if (exists) {
            exists.aantalDeeg(parseInt(exists.aantalDeeg()) + parseInt(orderline.aantalDeeg()));
            exists.includeMachines(exists.includeMachines() || orderline.includeMachines());

            exists.aantalMachines(parseInt(exists.aantalMachines()) + parseInt(orderline.aantalMachines()));

            exists.aantalGebakken(parseInt(exists.aantalGebakken()) + parseInt(orderline.aantalGebakken());


            } else {*/
            self.shoppingCart.push(orderline);
            // }

        }
        self.resetForm = function () {
            self.submitSuccess(false);
            self.submitted(false);
        }
        self.submitForm = function () {

            var valid = self.validator.form();
            self.formInvalid(valid);
            if (valid) {
                var shoppingCart = [];
                ko.utils.arrayForEach(self.shoppingCart(), function (item) {
                    var orderLine = {
                        postID: item.item().postID,
                        aantalDeeg: parseInt(item.aantalDeeg()),
                        includeMachines: item.includeMachines() == true,
                        aantalGebakken: parseInt(item.aantalGebakken()),
                        aantalMachines: parseInt(item.aantalMachines())
                    };

                    shoppingCart.push(orderLine);
                });
                var contactData = {
                    "Voornaam": self.contactInfo_Voornaam(),
                    "FamilieNaam": self.contactInfo_FamilieNaam(),
                    "Straat": self.contactInfo_Adres_Straat(),
                    "Nummer": self.contactInfo_Adres_Nummer(),
                    "Postcode": self.contactInfo_Adres_Postcode(),
                    "Stad": self.contactInfo_Adres_Stad(),
                    "Telefoon": self.contactInfo_Telefoon(),
                    "Email": self.contactInfo_Email()
                };
                var data = {
                    "shoppingCart": shoppingCart,
                    "startDatum": self.datum_afhalen,
                    "eindDatum": self.datum_terugbrengen,
                    "contactData": contactData,
                    "comment": self.comment(),
                    "action": "calculate_bestelling"
                };
                self.submitted(true);
                jQuery.ajax({
                    url: "../wp-admin/admin-ajax.php",
                    data: data,
                    dataType: "json",
                    method: "POST"
                }).done(function (response, e) {
                    if (response.success) {
                        self.submitSuccess(true);
                        self.shoppingCart([]);
                        self.contactInfo_Voornaam("");
                        self.contactInfo_FamilieNaam("");
                        self.contactInfo_Adres_Straat("");
                        self.contactInfo_Adres_Nummer(""),
                    self.contactInfo_Adres_Postcode("");
                        self.contactInfo_Adres_Stad("");
                        self.contactInfo_Telefoon("");
                        self.contactInfo_Email("");
                        self.comment("");
                    }
                });
            };
        };
    }


    if (typeof _shopitems !== 'undefined') {
        shopItems = _shopitems;
    }

    ko.bindingHandlers.modal = {
        init: function (element, valueAccessor) {
            jQuery(element).modal({
                show: false
            });

            var value = valueAccessor();
            if (ko.isObservable(value)) {
                jQuery(element).on('hide.bs.modal', function () {
                    value(false);
                });
            }



        },
        update: function (element, valueAccessor) {
            var value = valueAccessor();
            if (ko.utils.unwrapObservable(value)) {
                jQuery(element).modal('show');
            } else {
                jQuery(element).modal('hide');
           
            }
        }
    }
    var validator = jQuery("#form_bestelformulier").validate({

        errorContainer: "#errormsgs",
         errorLabelContainer: "#errormsgs ul",
         wrapper: "li",
         highlight: function(element) {
        jQuery(element).closest('div').addClass('has-error');
    },
    unhighlight: function(element) {
        jQuery(element).closest('div').removeClass('has-error');
    }
    });
    ko.applyBindings(new BestelFormulier(shopItems,validator));

    

};